import React, { useState, useEffect } from "react";

const VISIBLE_LIMIT = 5;

const SelectedRecipientsPanel = ({ recipients, onRemove }) => {
    const [showAll, setShowAll] = useState(false);
    const visible = recipients.slice(0, VISIBLE_LIMIT);
    const overflowCount = recipients.length - visible.length;

    useEffect(() => {
        if (recipients.length === 0) setShowAll(false);
    }, [recipients.length]);

    if (recipients.length === 0) return null;

    return (
        <div className="selected-recipients-panel mb-3">
            <div className="recip-head">
                <span className="field-label" style={{ margin: 0 }}>Selected Recipients</span>
                <span className="recip-count">{recipients.length} selected</span>
            </div>
            <div className="selected-recipients-panel__chips">
                {visible.map((person) => (
                    <span key={person._id} className="recipient-chip">
                        <span className="recipient-chip__text">
                            {person.fullName} ({person.email})
                        </span>
                        <button
                            type="button"
                            className="recipient-chip__remove"
                            onClick={() => onRemove(person._id)}
                            aria-label={`Remove ${person.fullName}`}
                        >
                            &times;
                        </button>
                    </span>
                ))}
                {overflowCount > 0 && (
                    <button
                        type="button"
                        className="recipient-chip recipient-chip--view-all"
                        onClick={() => setShowAll(true)}
                    >
                        View all ({recipients.length})
                    </button>
                )}
            </div>

            {showAll && (
                <div
                    className="modal-overlay"
                    onClick={(e) => {
                        if (e.target === e.currentTarget) setShowAll(false);
                    }}
                >
                    <div className="modal-box modal-box-wide">
                        <div className="modal-head">
                            <span className="modal-title">
                                Selected Recipients ({recipients.length})
                            </span>
                            <button
                                type="button"
                                className="modal-close"
                                aria-label="Close"
                                onClick={() => setShowAll(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="modal-body" style={{ padding: 0 }}>
                            <table className="table recipient-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Group(s)</th>
                                        <th style={{ width: "60px" }} />
                                    </tr>
                                </thead>
                                <tbody>
                                    {recipients.map((person) => (
                                        <tr key={person._id}>
                                            <td className="name-cell">{person.fullName}</td>
                                            <td>{person.email}</td>
                                            <td className="group-pill">{person.group || "-"}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="remove-row-btn"
                                                    onClick={() => onRemove(person._id)}
                                                    aria-label={`Remove ${person.fullName}`}
                                                >
                                                    &times;
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SelectedRecipientsPanel;
